import { render, staticRenderFns } from "./document-scroller.vue?vue&type=template&id=597e53b0&scoped=true"
import script from "./document-scroller.vue?vue&type=script&lang=js"
export * from "./document-scroller.vue?vue&type=script&lang=js"
import style0 from "./document-scroller.vue?vue&type=style&index=0&id=597e53b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e53b0",
  null
  
)

export default component.exports